import { api, ApiTags } from '../../api';
import type { UserScoreResponse, UserScoreRequest } from './types';

/**
 * API сервис для работы с лидербордом
 */
const leaderboardApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получает score текущего пользователя
         */
        getUserScore: build.query<UserScoreResponse, UserScoreRequest>({
            query: () => '/leaderboard/score',
            providesTags: [{ type: ApiTags.Leaderboard, id: 'USER_SCORE' }],
        }),
    }),
});

export const { useGetUserScoreQuery, useLazyGetUserScoreQuery } = leaderboardApi;
